'use strict';

import React, { Component } from 'react'

import Slider from 'react-slick'

import _ from 'lodash'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

const moment = window.moment;

const { app, qwest } = window;

export default class AdminBlogPage extends Component
{
	state =
	{
		article: { },
		references: [],
		loading: false
	};

	componentDidUpdate ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			type: 'synergies',
			id: id
		};

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'blog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			if ([true, 'true'].includes(response.data[0]?.disabled))
			{
				return component.setState({ loading: false });
			}

			component.setState(
			{
				article: response.data[0],
				references: response.references,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, article = component.state.article;

		const moment = window.moment;

		let loader, theme;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		let images = (article.images || []).map(function (data, index)
		{
			var output =
			(
				<div key={ index }>
					<Image className="c-model__carousel-image" src={ data.url } />
				</div>
			);

			return output;
		});

		const slider_settings =
		{
			dots: true,
			infinite: false,
			speed: 320,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			useCSS: true,
			breakpoint: 100,
			draggable: true
		};

		let slider;

		if (images.length)
		{
			slider =
			(
				<div className="o-grid__item-5">

					<div className="c-model__images">
						<Slider { ...slider_settings }>
							{ images }
						</Slider>
					</div>

				</div>
			);
		}

		let pdf_files = (article.pdfs || [])
		.filter(data => Boolean(data))
		.map(function (file, i)
		{
			let output =
			(
				<div className="u-full-width u-margin-top-10" key={ i }>
					<Link href={ file.url } type="application/pdf" target="_blank">
						{ file.filename }
					</Link>
				</div>
			);

			return output;
		});

		let pdf_files_title;

		if (pdf_files.length > 0)
		{
			pdf_files_title =
			(
				<div className="c-subtitle u-margin-top-30">
					<div className="c-subtitle__txt">
						Pièces jointes
					</div>
				</div>
			);
		}

		let output =
		(
			<Layout page_title={ article.title || 'Article' }
				history={ props.history }>

				<div className="page-content c-model c-model--article">

					<HolidaysMessage />

					<div className="o-grid">

						{ slider }

						<div className={ slider ? 'o-grid__item-7' : 'o-grid__item-12 u-full-width' }>

							<div className="c-title u-no-margin-top">
								<h2 className="c-title__txt">
									{ article.title }
								</h2>
							</div>

							<div className="c-model__body">

								<div className="c-model__themes">
									<div className="c-model__theme">
										{ moment(article.date).format('DD MMMM YYYY') }
									</div>
								</div>

								<div className="c-model__description"
									dangerouslySetInnerHTML={ { __html: article.content } }>
								</div>

								{ pdf_files_title }

								{ pdf_files }

							</div>

						</div>

						{ loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
